// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  //apiUrl: 'https://adminapi.igeet.com/v1',
  apiUrl: 'http://localhost:3000/v1',
  mediaApiUrl: 'https://media.igeet.com',
  mediaUrl: 'https://media.igeet.com/cdn/',
  // mediaUrl: 'http://localhost:3010/cdn/',
   mediaPath: 'http://localhost:3010',
  appVersion: '1.0.0',
  languages: [{ id: 1, code: 'en', label: 'English' }, { id: 2, code: 'hi', label: 'Hindi' }]
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
